module.exports = __webpack_public_path__ + "static/media/youtube-ads.184d875f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/youtube-ads.png
// module id = 372
// module chunks = 0